<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">

      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
        label-width="100px" :rules="rules">
        <el-row>
          <el-col :span="7">
            <el-form-item label="日期" prop="title">
              <el-input readonly v-model="formParameter.crtm" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="title">
              <el-select v-model="slkedZxid" v-if="zxs" @change="chgSlkedZx" placeholder="请选择">
                <el-option v-for="itm in zxs" :key="itm.id" :label="itm.name" :value="itm.id">
                </el-option>
              </el-select>
              <b v-else>{{ formParameter.dbColumn_crer }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最后更新" prop="title">
              <el-input readonly v-model="formParameter.mdtm" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item  prop="mgr">
              <el-button    v-has-permission-code-and="'003000550025'"  v-if="page.current==1 && (me.id != formParameter.crer) && (!showMgr)" type="success" @click="showSend">指导</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="pageBar">
              <el-pagination :total="listData.total"   :pager-count="11" :page-size="page.size" :current-page="page.current"
                @current-change="currentChange" layout="prev, pager, next"
                :page-sizes="this.$constant.page.pageSizes"></el-pagination>
            </div>
          </el-col>
        </el-row>
        <el-row v-show="showMgr">
          <el-col  :span="20">
            <el-form-item  label="主管意见:" prop="mgr">
              <el-input   
                type="textarea"
                :rows="3"
                v-model="formParameter.mgrcnt"
                autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col  :span="4">
            <el-form-item    prop="mgr">
                <el-button   v-has-permission-code-and="'003000550020'" v-if="page.current==1" type="success"   :loading="confirmLoading" @click="sendMgrCnt()">提交意见</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="24">
            <el-form-item label="内容:" prop="content">
              <wang-edit v-if="me.id == formParameter.crer" v-model="formParameter.content"
                :isupdt="isUpdtWedit"></wang-edit>
              <div v-else id="content-html" v-html="formParameter.content"></div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button @click="close">关 闭</el-button>
      <el-button type="primary" v-if="me.id == formParameter.crer && page.current == 1" :loading="confirmLoading" @click="confirm()">提 交</el-button>

    </div>
  </popup>
</template>

<script>

import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/consu/consultationxl/consuxldoc.js";
import wangEdit from "@/components/wangEdit/wangEdit.vue";

export default {
  name: "edit",
  components: {
    popup,
    wangEdit
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      searchParams: {},
      formParameter: {},
      me: {},
      showMgr:false,
      listData: {},
      page: new this.$constant.pageObj(),
      zxs: false,
      slkedZxid: "",
      rules: {
        //公文正文
        content: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],

      },
      isUpdtWedit: false   //用于更新wangEdit
    };
  },
  methods: {

    showSend(){
        this.showMgr =true
        this.formParameter.mgr = this.me.name
        console.log("this.formParameter.mgr",this.formParameter.mgr)
    },sendMgrCnt(){

      api.leadTo(  {id:this.formParameter.id,mgr:this.formParameter.mgr,mgrcnt:this.formParameter.mgrcnt},res=>{
        this.$utils.msg.success("添加成功");
      })

    },
    //改变现在的页码
    currentChange(val) {

      if( this.listData.total>2 || val!= this.listData.total){
        this.page.current = val;
        this.list();
      }else{
        this.$utils.msg.warning("最后一页占位没数据");
      }
  
    }, chgSlkedZx() {

      this.searchParams.id = this.slkedZxid
      this.list()

    },
    //打开弹框
    open() {
      this.formParameter = {};

      this.page.size = 1
      this.$refs.popup.open("招生备忘", "50%");

      // 前端取回自己
      this.me = this.$caches.user.get();
      //默认查自己
      this.searchParams.id =this.me.id

      if (this.me.id == "1" || this.me.id == "56493ffc15800a66a6962cc030c66eeb") {
        this.zxs = this.$caches.users.get().zxs;

        this.zxs.unshift({ name: "Rick",id:'1' });
        this.zxs.unshift({ name: "杨佳敏",id:'56493ffc15800a66a6962cc030c66eeb' });

        this.slkedZxid = this.me.id
      }else if(  this.me.role2 == "qdm"){
       
        this.zxs = [{ name:this.me.name,id:this.me.id }];
        this.zxs = this.zxs.concat(this.$caches.users.get().zxs );  
      }
      this.list();

    }, list() {

      this.listLoading = true;

      let params = this.$utils.merger(this.searchParams, this.page);
      params.x = Math.random()

      api.list(params, res => {
        this.listData = res.data

        if (this.listData.records && this.listData.records[0]) {
          this.isUpdtWedit = true
          this.formParameter = this.listData.records[0]
          //  console.log("this.formParameter", this.formParameter)
          if( this.formParameter.crer != this.me.id && ( !this.formParameter.mgr )){
            this.formParameter.mgr = this.me.name
           }

           if( this.formParameter.mgrcnt ){
             this.showMgr = true
           }else{
             this.showMgr = false
           }
          

          setTimeout(() => {
            this.isUpdtWedit = false
          }, 100)

        } else {
          console.log("没有记录")
          this.formParameter = {}
          this.formParameter.content = "没有记录"
        }

        this.listLoading = false;
      })
    },
    //关闭弹框
    close() {
      this.formParameter = {}
      this.isUpdtWedit = false
      this.disabled = false;
      this.$refs.popup.close();
    },
    //提交表单/
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {

        this.confirmLoading = true;

        let parameter = {}
        if (this.formParameter.id) {
          parameter.id = this.formParameter.id
        }
        parameter.content = this.formParameter.content

        api.merge(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);

            this.formParameter.mdtm = response.data.mdtm
            this.formParameter.id = response.data.id

            this.confirmLoading = false;
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

#content-html {
  border: 1px solid #b0b2b3 !important;
  padding: 5px;
}

/deep/.w-e-text-container {
  height: 580px !important;
  /*!important是重点，因为原div是行内样式设置的高度300px*/
}
</style>
